import { render } from "./Banks.vue?vue&type=template&id=d6fb6c72&scoped=true&ts=true"
import script from "./Banks.vue?vue&type=script&lang=ts"
export * from "./Banks.vue?vue&type=script&lang=ts"

import "./Banks.vue?vue&type=style&index=0&id=d6fb6c72&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fb6c72"]])

export default __exports__